import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { initGTM } from './utils/gtm';
import { initMixpanel } from './utils/mixpanel.ts';
import armsInit from './utils/armsRum.ts';
import 'quill/dist/quill.snow.css';

armsInit();

// Initialize GTM in production environment
initGTM();

initMixpanel();

createRoot(document.getElementById('root')!).render(<App />);
